import * as yup from 'yup'

export const schema = yup.object().shape({
  reason: yup.string().required(),
})

export default schema
